var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import segmentPlugin from '@analytics/segment';
import Analytics from 'analytics';
let analyticsInstance;
const getAnalyticsInstance = (callback) => {
    if (analyticsInstance) {
        return analyticsInstance;
    }
    if (typeof window !== 'undefined') {
        const writeKey = getWriteKey();
        if (!writeKey) {
            const error = new Error(`@lendi/analytics: segment write id is not given, so we can't track your events.`);
            // eslint-disable-next-line no-console
            callback ? callback(error) : console.error(error);
        }
        const config = {
            flushAt: +(process.env.LENDI_ANALYTICS_FLUSH_AT || 0),
            flushInterval: +(process.env.LENDI_ANALYTICS_FLUSH_INTERVAL || 0),
            enable: process.env.LENDI_ANALYTICS_ENABLE !== 'true',
            debug: process.env.LENDI_ANALYTICS_DEBUG === 'true',
        };
        analyticsInstance = Analytics({
            debug: config.debug,
            plugins: [
                segmentPlugin(Object.assign({ writeKey }, config)),
            ],
        });
        return analyticsInstance;
    }
};
/**
 * @deprecated We do not encourage to this method anymore so start using to LendiAnalyticsV2 from the same package by upgrading
 */
export const identify = (userId, traits, options, callback) => {
    return getAnalyticsInstance(callback).identify(userId, traits, options);
};
/**
 * @deprecated We do not encourage to this method anymore so start using to LendiAnalyticsV2 from the same package by upgrading
 */
export const trackPage = (category, name, callback) => {
    return getAnalyticsInstance(callback).page({
        category,
        name,
    });
};
/**
 * @deprecated We do not encourage to this method anymore so start using to LendiAnalyticsV2 from the same package by upgrading
 */
export const trackEvent = (trackingEvent, options, callback) => {
    const { event_name } = trackingEvent, payload = __rest(trackingEvent, ["event_name"]);
    if (typeof window !== 'undefined') {
        payload.path = location.href.replace(location.origin, '');
    }
    return getAnalyticsInstance(callback).track(event_name, payload, options);
};
const getWriteKey = () => {
    const hostname = window.location.hostname;
    if (hostname.indexOf('aussie') !== -1) {
        return process.env.REACT_APP_AUSSIE_SEGMENT_ID || process.env.NEXT_PUBLIC_AUSSIE_SEGMENT_ID;
    }
    else if (hostname.indexOf('domain') !== -1 || hostname.indexOf('dlf') !== -1) {
        return process.env.REACT_APP_DLF_SEGMENT_ID;
    }
    else {
        return (process.env.REACT_APP_SEGMENT_ID || process.env.NEXT_PUBLIC_SEGMENT_ID || process.env.GATSBY_SEGMENT_ID);
    }
};
//# sourceMappingURL=ClientLendiAnalytics.js.map